import {
  applySnapshot,
  getSnapshot,
  Instance,
  SnapshotIn,
  SnapshotOut,
  types,
} from "mobx-state-tree";
import {
  AssignEmailCycleStore,
  createAssignEmailCycleStore,
} from "./AssignEmailCycleStore";
import {
  createPendingSurveyAssignmentErrorModel,
  PendingSurveyAssignmentErrorModel,
} from "../models/PendingSurveyAssignmentErrorModel";
import {
  createCreateEmailCycleStore,
  CreateEmailCycleStore,
} from "./CreateEmailCycleStore";

const getInitialState = (): SnapshotIn<
  typeof CreateOrAssignEmailCycleStore
> => ({
  assignEmailCycleStore: createAssignEmailCycleStore(),
  createEmailCycleStore: createCreateEmailCycleStore(),
  pendingSurveyAssignmentError: null,
  missingEmailIdError: null,
});

export const CreateOrAssignEmailCycleStore = types
  .model("CreateOrAssignEmailCycleStore", {
    assignEmailCycleStore: AssignEmailCycleStore,
    createEmailCycleStore: CreateEmailCycleStore,
    pendingSurveyAssignmentError: types.maybeNull(
      PendingSurveyAssignmentErrorModel,
    ),
    missingEmailIdError: types.maybeNull(types.integer),
  })
  .actions((store) => ({
    setPendingSurveyAssignmentError: (
      pendingSurveyAssignmentError: SnapshotIn<
        typeof PendingSurveyAssignmentErrorModel
      >,
    ): void => {
      store.pendingSurveyAssignmentError =
        createPendingSurveyAssignmentErrorModel(pendingSurveyAssignmentError);
    },
    setMissingEmailIdError: (
      missingEmailIdError: SnapshotOut<
        typeof CreateOrAssignEmailCycleStore
      >["missingEmailIdError"],
    ): void => {
      store.missingEmailIdError = missingEmailIdError;
    },
    resetStore: (): void => {
      const { pendingSurveyAssignmentError, missingEmailIdError } =
        getInitialState();
      applySnapshot(store, {
        ...getSnapshot(store),
        pendingSurveyAssignmentError,
        missingEmailIdError,
      });
    },
  }));

export const createCreateOrAssignEmailCycleStore = (): Instance<
  typeof CreateOrAssignEmailCycleStore
> => CreateOrAssignEmailCycleStore.create(getInitialState());
